import React from 'react';
import './WidgetWrapper.css';

const WidgetWrapper = ({
  children,
  type,
  theme,
  bgColor,
  borderType = 'default', // kept for API compatibility, border is now on the grid item
  style = {}
}) => {
  const themeClass = theme?.id === 'modern' ? 'modern' : 'classic';
  const wrapperClass = `widget-wrapper widget-wrapper--${type} widget-wrapper--${type}--${themeClass}`;

  const customStyle = {
    borderRadius: 'var(--dashboard-border-radius, 35px)',
    border: 'none',
    backgroundColor: bgColor || 'var(--white)',
    ...style
  };

  return (
    <div className={wrapperClass} style={customStyle}>
      {children}
    </div>
  );
};

export default WidgetWrapper;